import { render, staticRenderFns } from "./SessionObservationPage.vue?vue&type=template&id=faef0c60"
import script from "./SessionObservationPage.vue?vue&type=script&lang=js"
export * from "./SessionObservationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports